export const QueueTypes = {
    QUEUE_ADD: "QUEUE_ADD",
    QUEUE_REMOVE: "QUEUE_REMOVE",
    QUEUE_INCREASE_FAIL_ATTEMPS_COUNT: "QUEUE_INCREASE_FAIL_ATTEMPS_COUNT",
}